import { getUserAddress } from 'core/api';
import { useAuthorization } from 'core/context';
import { useToast } from 'core/toast';
import { useEffect, useState } from 'react';

export const useUserAddress = () => {
    const authState = useAuthorization();
    const { setToastMessage } = useToast();
    const [ userAddress, setUserAddress ] = useState({
        id: '',
        address: '',
        city: '',
        region: '',
        country: '',
        postal: '',
        suite: ''
    });
    const [ fullAddress, setFullAddress ] = useState('');

    const getCurrentUserAddress = async () => {
        const { success, userAddress } = await getUserAddress(authState);

        if (!success) return setToastMessage('Failed to load user address');
        
        const { id, address, city, region, country, postal, suite } = userAddress;

        setUserAddress({ id, address, city, region, country, postal, suite });

        const full_address = `${address}, ${city}, ${region}, ${country}`;

        setFullAddress(full_address);
    };

    useEffect(() => {
        getCurrentUserAddress();
    }, []);

    return { userAddress, fullAddress };
};
